(function () {
  'use strict';

  const MAX_QTY = 4;

  function getProductQuantityInputs() {
    return document.querySelectorAll(
      'input[name="quantity"], input.quantity__input, input[data-quantity-input]'
    );
  }

  function limitInput(input) {
    if (!input) return;

    input.setAttribute('max', MAX_QTY);
    input.max = MAX_QTY;

    const currentValue = parseInt(input.value, 10);

    if (!isNaN(currentValue) && currentValue > MAX_QTY) {
      input.value = MAX_QTY;
    }
  }

  function showLimitMessage() {
    let message = document.getElementById('quantity-limit-message');

    if (!message) {
      message = document.createElement('div');
      message.id = 'quantity-limit-message';

      message.style.cssText = `
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 99999;
        background: #111;
        color: #fff;
        padding: 12px 18px;
        border-radius: 6px;
        font-size: 14px;
        line-height: 1.4;
        max-width: 90%;
        text-align: center;
        box-shadow: 0 4px 15px rgba(0,0,0,.25);
      `;

      document.body.appendChild(message);
    }

    message.textContent =
      'Maximum 4 units of the same product can be ordered.';

    clearTimeout(message._timer);

    message._timer = setTimeout(function () {
      message.remove();
    }, 3000);
  }

  function enforceQuantityInputs() {
    getProductQuantityInputs().forEach(limitInput);
  }

  /*
   * Prevent quantity inputs from going above 4.
   */
  document.addEventListener('input', function (event) {
    const input = event.target;

    if (
      input.matches(
        'input[name="quantity"], input.quantity__input, input[data-quantity-input]'
      )
    ) {
      const value = parseInt(input.value, 10);

      if (!isNaN(value) && value > MAX_QTY) {
        input.value = MAX_QTY;
        showLimitMessage();
      }

      if (value < 1 || isNaN(value)) {
        input.value = 1;
      }
    }
  });

  /*
   * Prevent quantity selector buttons from exceeding 4.
   */
  document.addEventListener('click', function (event) {
    const button = event.target.closest(
      'button[name="plus"], button.quantity__button--plus, .quantity__button[name="plus"]'
    );

    if (!button) return;

    const container = button.closest(
      'quantity-input, .quantity, .product-form__quantity, .quantity-selector'
    );

    if (!container) return;

    const input = container.querySelector('input');

    if (!input) return;

    const current = parseInt(input.value, 10) || 1;

    if (current >= MAX_QTY) {
      event.preventDefault();
      event.stopImmediatePropagation();

      input.value = MAX_QTY;
      showLimitMessage();
    }
  }, true);

  /*
   * Protect Shopify's AJAX cart API.
   */
  const originalFetch = window.fetch;

  window.fetch = async function () {
    const args = arguments;
    const url = args[0];

    if (
      typeof url === 'string' &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      )
    ) {
      try {
        let options = args[1];

        if (options && options.body) {
          let body = options.body;

          /*
           * Handle JSON requests.
           */
          if (
            typeof body === 'string' &&
            body.trim().startsWith('{')
          ) {
            const data = JSON.parse(body);

            /*
             * /cart/add.js
             */
            if (Array.isArray(data.items)) {
              let blocked = false;

              data.items.forEach(function (item) {
                if (parseInt(item.quantity, 10) > MAX_QTY) {
                  item.quantity = MAX_QTY;
                  blocked = true;
                }
              });

              if (blocked) {
                showLimitMessage();
                options.body = JSON.stringify(data);
              }
            }

            /*
             * /cart/change.js
             */
            if (
              data.quantity !== undefined &&
              parseInt(data.quantity, 10) > MAX_QTY
            ) {
              data.quantity = MAX_QTY;
              showLimitMessage();
              options.body = JSON.stringify(data);
            }

            /*
             * /cart/update.js
             */
            if (data.updates) {
              let changed = false;

              Object.keys(data.updates).forEach(function (key) {
                if (parseInt(data.updates[key], 10) > MAX_QTY) {
                  data.updates[key] = MAX_QTY;
                  changed = true;
                }
              });

              if (changed) {
                showLimitMessage();
                options.body = JSON.stringify(data);
              }
            }
          }

          /*
           * Handle FormData requests.
           */
          if (body instanceof FormData) {
            let changed = false;

            for (const [key, value] of body.entries()) {
              if (
                key.includes('quantity') &&
                parseInt(value, 10) > MAX_QTY
              ) {
                body.set(key, MAX_QTY);
                changed = true;
              }
            }

            if (changed) {
              showLimitMessage();
              options.body = body;
            }
          }
        }
      } catch (error) {
        console.warn('Quantity limit:', error);
      }
    }

    return originalFetch.apply(this, args);
  };

  /*
   * Protect XMLHttpRequest-based cart requests.
   */
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._quantityLimitMethod = method;
    this._quantityLimitURL = url;

    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    try {
      const url = this._quantityLimitURL;

      if (
        typeof url === 'string' &&
        (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update')
        )
      ) {
        if (typeof body === 'string') {
          try {
            const data = JSON.parse(body);

            if (Array.isArray(data.items)) {
              data.items.forEach(function (item) {
                if (parseInt(item.quantity, 10) > MAX_QTY) {
                  item.quantity = MAX_QTY;
                  showLimitMessage();
                }
              });
            }

            if (
              data.quantity !== undefined &&
              parseInt(data.quantity, 10) > MAX_QTY
            ) {
              data.quantity = MAX_QTY;
              showLimitMessage();
            }

            if (data.updates) {
              Object.keys(data.updates).forEach(function (key) {
                if (parseInt(data.updates[key], 10) > MAX_QTY) {
                  data.updates[key] = MAX_QTY;
                  showLimitMessage();
                }
              });
            }

            body = JSON.stringify(data);
          } catch (e) {
            // Not JSON — leave request unchanged.
          }
        }
      }
    } catch (error) {
      console.warn('Quantity limit XHR:', error);
    }

    return originalSend.call(this, body);
  };

  /*
   * Initial setup.
   */
  document.addEventListener('DOMContentLoaded', function () {
    enforceQuantityInputs();
  });

  /*
   * Shopify themes often dynamically replace cart/product elements.
   */
  const observer = new MutationObserver(function () {
    enforceQuantityInputs();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();